import { FInput } from '../../../components/baseV2';
import { READ_ONLY_FIELD_SX } from '../styles';

import type { FormFieldReadOnlyValueProps } from '../types';

export default function FormFieldReadOnlyValue({
  label,
  value,
  placeholder,
  required = false,
  multiline = false,
  minRows,
}: FormFieldReadOnlyValueProps) {
  const hasError = required && value.trim() === '';

  return (
    <FInput
      error={hasError}
      fullWidth
      InputProps={{ readOnly: true }}
      label={label}
      minRows={minRows}
      multiline={multiline}
      placeholder={placeholder}
      sx={READ_ONLY_FIELD_SX}
      value={value}
    />
  );
}
